import { Folder } from '@model/folder';
import { ToastrService } from 'ngx-toastr';
import { Treasury } from '@model/treasury';
import { Globals } from '@theme/utils/globals';
import { Component, HostListener, OnInit } from '@angular/core';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { InvoiceFolder } from '@model/invoice-folder';
import { PaymentCustomer } from '@model/payment-customer';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FileUploadValidators } from '@iplab/ngx-file-upload';
import { FolderService } from '@service/folder/folder.service';
import { ValidatorsEnums } from '@theme/enums/validators.enums';
import { EmitterService } from '@service/emitter/emitter.service';
import { CustomerService } from '@service/customer/customer.service';
import { TreasuryService } from '@service/treasury/treasury.service';
import { DateHelperService } from '@theme/utils/date-helper.service';
import { UploaderService } from '@service/uploader/uploader.service';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { FolderInvoiceService } from '@service/folder-invoice/folder-invoice.service';
import { PaymentCustomerService } from '@service/payment-customer/payment-customer.service';
import { UpdateComponent } from '@agence/modal/update/update.component';
import { WalletService } from '@service/wallet/wallet.service';
import { Wallet } from '@model/wallet';

@Component({
  selector: 'app-payment-customer-add',
  templateUrl: './payment-customer-add.component.html',
  styleUrls: ['./payment-customer-add.component.scss']
})
export class PaymentCustomerAddComponent implements OnInit {

  ESCAPE_KEYCODE = 27;
  title: string = '';
  form: FormGroup;
  submit: boolean = false;
  customerSelected?: any;
  customers = [];
  invoices: InvoiceFolder[];
  folders = [];
  treasuries = [];
  folder?: Folder;
  isLoadingFolder = false;
  edit: boolean = false;
  payment: PaymentCustomer;
  treasuryUuid: string = "";
  treasury: Treasury;
  montantRegle: any = 0;
  montantRestant: any = 0;
  sourceTitle: string = "";
  numeroTitle: string = "";
  isHidden: boolean;
  periode: any;
  uuid: any;
  total: number = 0;
  total_paye: number = 0;
  total_impaye: number = 0;
  required = Globals.required;
  userSession = Globals.user;
  global = { country: Globals.country, device: Globals.device };

  // Gestion du wallet
  wallet: Wallet;
  utiliserWallet: boolean = false;
  montantWalletUtilise: number = 0;
  montantWalletSaisi: number = 0; // Montant wallet choisi par l'utilisateur
  montantRestantAPayer: number = 0;
  loadingWallet: boolean = false;

  // Type de paiement : loyer, charges, ou les deux
  typePaiement: 'LOYER_ET_CHARGES' | 'LOYER_SEUL' | 'CHARGES_SEULES' = 'LOYER_ET_CHARGES';

  // Répartition intelligente
  modeRepartition: 'AUTOMATIQUE' | 'MANUELLE' = 'AUTOMATIQUE';
  montantTotal: number = 0;
  montantEcheancesDues: number = 0;
  montantEcheancesSelectionnees: number = 0; // Total des échéances cochées
  montantSurplus: number = 0;
  repartitionPreview: any[] = [];

  modeRow = [
    { label: "Espèce", value: "ESPECE" },
    { label: "Chèque", value: "CHEQUE" },
    { label: "Mobile money", value: "MOBILE MONEY" },
    { label: "Wave", value: "WAVE" },
    { label: "Versement", value: "VERSEMENT" },
    { label: "Virement", value: "VIREMENT" },
    { label: "Wallet", value: "WALLET" }
  ]
  typeFactureRow = [
    { label: "Dossier", value: "DOSSIER" },
    { label: "Résiliation", value: "RESILIATION" }
  ]

  constructor(
    public toastr: ToastrService,
    public modal: NgbActiveModal,
    private modalService: NgbModal,
    private formBuild: FormBuilder,
    private emitter: EmitterService,
    public folderService: FolderService,
    public uploadService: UploaderService,
    public customerService: CustomerService,
    private treasuryService: TreasuryService,
    public folderInvoiceService: FolderInvoiceService,
    public paymentCustomerService: PaymentCustomerService,
    public walletService: WalletService
  ) {
    this.edit = this.paymentCustomerService.edit;
    this.treasuryUuid = this.paymentCustomerService.treasury;
    this.payment = this.paymentCustomerService.getPayment();
    this.title = (!this.edit) ? "Ajouter un paiement" : "Modifier le paiement de " + this.payment?.invoice?.folder?.customer?.searchableTitle
    this.newForm();
    this.setTreasury()
  }

  ngOnInit(): void {
    this.editForm();
  }

  newForm() {
    this.form = this.formBuild.group({
      uuid: [null],
      id: [null],
      treasury: [null],
      folderUuid: [null],
      type: [null, Validators.required],
      customer: [null, Validators.required],
      folder: [null, Validators.required],
      montant: [0, [Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
      date: [null, Validators.required],
      mode: ['ESPECE', Validators.required],
      montantVerse: [0],
      effectue: [null, Validators.required],
      source: [null],
      numero: [null],
      tiers: [null],
      typePaiement: ['LOYER_ET_CHARGES'],
      files: [null, FileUploadValidators.filesLimit(3)],
      options: this.formBuild.array(this.itemOption()),
      echeanceFolders: this.formBuild.array([]),
      avanceFolders: this.formBuild.array([]),
      folders: this.formBuild.array([]),
    });
  }

  setTreasury() {
    if (this.treasuryUuid) {
      this.f.treasury.setValue(this.treasuryUuid)
      this.treasuryService.getSingle(this.treasuryUuid).subscribe((res: any) => {
        if (res) {
          this.treasury = res;
          if (this.treasury.type === "CAISSE") {
            this.modeRow = [
              { label: "Espèce", value: "ESPECE" },
              { label: "Mobile money", value: "MOBILE MONEY" },
              { label: "Wave", value: "WAVE" },
              { label: "Wallet", value: "WALLET" }
            ]
          }
          if (this.treasury.type === "BANQUE") {
            this.modeRow = [
              { label: "Chèque", value: "CHEQUE" },
              { label: "Versement", value: "VERSEMENT" },
              { label: "Virement", value: "VIREMENT" },
              { label: "Wallet", value: "WALLET" }
            ]
          }
          return this.treasury
        }
      });
    }
  }

  editForm() {
    if (this.edit) {
      const data = { ...this.paymentCustomerService.getPayment() };
      data.date = DateHelperService.fromJsonDate(data.date);
      this.customerSelected = {
        photoSrc: data?.invoice?.folder?.customer?.photoSrc,
        title: data?.invoice?.folder?.customer?.searchableTitle,
        detail: data?.invoice?.folder?.customer?.searchableDetail
      };
      //@ts-ignore
      data?.type = data?.invoice?.type;
      //@ts-ignore
      data?.customer = data?.invoice?.folder?.customer?.uuid;
      //@ts-ignore
      data?.folder = data?.invoice?.folder?.uuid;
      this.form.patchValue(data);
      this.f.folderUuid.setValue(this.payment.folder.uuid);
      this.option.push(
        this.formBuild.group({
          checked: [true],
          libelle: [{ value: data?.invoice.libelle, disabled: true }],
          montant: [{ value: data?.invoice?.montant, disabled: true }],
          paye: [{ value: data?.invoice?.paye, disabled: true }],
          impaye: [{ value: data?.invoice?.impaye, disabled: true }]
        })
      );
      this.montantRestant = data?.invoice?.impaye;
      this.montantTotal = data?.invoice?.montant;
      this.montantRegle = data?.invoice?.paye;
    }
  }

  setCustomerUuid(uuid) {
    if (uuid) {
      this.customerService.getSingle(uuid).subscribe((res: any) => {
        if (res.etat === 'ACTIF') {
          this.f.customer.setValue(uuid);
          // ✅ NOUVEAU : Charger le wallet du client
          this.loadWallet();
        } else {
          this.f.customer.setValue(null);
          this.toast('Désolez, ce client n\'a aucun dossier actif', 'Dossier inactif', 'warning');
        }
      })
    } else {
      this.folders = [];
      this.option.clear()
      this.f.folder.setValue(null);
      // Réinitialiser le wallet
      this.wallet = null;
      this.utiliserWallet = false;
      this.calculerMontantAvecWallet();
    }
  }

  loadFolders() {
    this.option.clear()
    this.isLoadingFolder = true;
    if (!this.f.customer.value) {
      this.isLoadingFolder = false;
      this.folders = [];
      return;
    }
    var etat = this.f.type.value === "RESILIATION" ? 'RESILIE' : 'VALIDE';
    this.folderService.getList(this.f.customer.value, etat).subscribe(res => {
      this.isLoadingFolder = false;
      return this.folders = res;
    }, error => {
      this.isLoadingFolder = false;
    });
  }

  setFolderUuid(event) {
    var uuid = event.target.value
    if (event.target.value !== null) {
      this.folder = this.folders.find(item => {
        if (item.uuid === uuid) {
          this.f.folder.setValue(item.uuid);

          // ✅ NOUVEAU : Sélection automatique de la facture (masquée)
          this.loadInvoice(this.f.type.value);
          // La sélection automatique se fera dans loadInvoice après le chargement

          // Charger le wallet du client
          this.loadWallet();
          return item;
        }
      });
    }
    if (this.folder?.invoice?.rembourser > 0) {
      this.isHidden = true
    }
    if (!this.folder) {
      this.toast('Veuillez selectionner un dossier', 'Erreur', 'danger');
      return;
    }
    if (this.folder) {
      // Charger les échéances/avances pour affichage
      this.chargerEcheancesOuAvances();
    }
    this.form.get('folder').setValue(this.folder.uuid);
  }

  /**
   * ✅ NOUVEAU : Sélectionne automatiquement la facture du dossier
   */
  selectionnerFactureAutomatiquement() {
    setTimeout(() => {
      if (this.invoices && this.invoices.length > 0 && this.option.controls.length > 0) {
        // Sélectionner automatiquement la première (et unique) facture
        this.option.controls[0]?.get('checked')?.setValue(true);
        // Appeler onSelectInvoice pour mettre à jour les montants
        this.onSelectInvoice();

        console.log('✅ Facture sélectionnée automatiquement');
        console.log('Checked:', this.option.controls[0]?.get('checked')?.value);
        console.log('Options dans le form:', this.form.value.options);
      }
    }, 100);
  }

  /**
   * ✅ NOUVEAU : Charge les échéances ou avances SANS les pré-sélectionner
   */
  chargerEcheancesOuAvances() {
    this.avanceFolders.controls.length = 0;
    this.echeanceFolders.controls.length = 0;

    if (this.folder?.modalite === "ECHEANCE") {
      this.folder?.echeances.forEach(item => {
        if (item?.etat === 'IMPAYE' || item?.etat === 'ATTENTE') {
          const montantParType = this.getMontantEcheanceParType(item);
          this.echeanceFolders.controls.push(
            this.formBuild.group({
              uuid: [item?.uuid],
              id: [item?.id],
              checked: [false],
              date: [{ value: DateHelperService.fromJsonDate(item?.date), disabled: true }],
              etat: [{ value: item?.etat, disabled: true }],
              montant: [{ value: montantParType, disabled: true }],
              montantTotal: [{ value: item?.montant, disabled: true }],
              mensualiteBase: [{ value: item?.mensualiteBase ?? 0, disabled: true }],
              charge: [{ value: item?.charge ?? 0, disabled: true }],
              montantRestant: [{ value: montantParType, disabled: true }],
              montantRestantLoyer: [{ value: item?.montantRestantLoyer, disabled: true }],
              montantRestantCharge: [{ value: item?.montantRestantCharge, disabled: true }],
              description: [{ value: item?.description, disabled: true }],
            })
          );
        }
      });

      // Calculer le total des échéances dues
      this.calculerMontantEcheancesDues();
    }

    if (this.folder?.modalite === "AVANCEMENT") {
      this.folder?.advances.forEach(item => {
        if (item?.etat === 'IMPAYÉ' || item?.etat === 'ATTENTE') {
          this.avanceFolders.controls.push(
            this.formBuild.group({
              uuid: [item?.uuid],
              id: [item?.id],
              checked: [false], // Non coché par défaut
              libelle: [{ value: item?.libelle, disabled: true }],
              etat: [{ value: item?.etat, disabled: true }],
              prc: [{ value: item?.prc, disabled: true }],
              montant: [{ value: item?.montant, disabled: true }],
            })
          );
        }
      });
    }
  }

  /**
   * Retourne le montant d'une échéance selon le type de paiement sélectionné
   */
  getMontantEcheanceParType(item: any): number {
    switch (this.typePaiement) {
      case 'LOYER_SEUL':
        // Utiliser montantRestantLoyer si > 0, sinon mensualiteBase
        const restantLoyer = item.montantRestantLoyer;
        return (restantLoyer !== null && restantLoyer !== undefined && restantLoyer > 0)
          ? restantLoyer : (item.mensualiteBase ?? 0);
      case 'CHARGES_SEULES':
        // Utiliser montantRestantCharge si > 0, sinon charge
        const restantCharge = item.montantRestantCharge;
        return (restantCharge !== null && restantCharge !== undefined && restantCharge > 0)
          ? restantCharge : (item.charge ?? 0);
      case 'LOYER_ET_CHARGES':
      default:
        // Comportement original : utiliser montant total
        return item.montant ?? 0;
    }
  }

  /**
   * Handler pour le changement de type de paiement
   */
  onTypePaiementChange(type: 'LOYER_ET_CHARGES' | 'LOYER_SEUL' | 'CHARGES_SEULES') {
    this.typePaiement = type;
    this.form.get('typePaiement').setValue(type);

    // Recharger les échéances avec les montants recalculés
    if (this.folder) {
      this.chargerEcheancesOuAvances();
    }

    // Recalculer les montants
    this.calculerMontantAvecWallet();
  }

  loadInvoice(type) {
    this.option.clear()
    this.folderInvoiceService.getList(this.f.folder.value, null, type).subscribe((res) => {
      //@ts-ignore
      this.invoices = res
      if (this.invoices) {
        this.option.controls = this.itemOption()
        // ✅ NOUVEAU : Sélectionner automatiquement après chargement
        this.selectionnerFactureAutomatiquement();
      }
    }, error => { }
    );
  }

  itemOption(): FormGroup[] {
    var arr: any[] = []
    if (this.invoices && this.invoices.length > 0) {
      this.invoices.forEach((item, index) => {
        arr.push(
          this.formBuild.group({
            uuid: [item.uuid],
            checked: [index === 0], // ✅ Sélectionner automatiquement la première facture
            libelle: [{ value: item?.libelle, disabled: true }],
            montant: [{ value: this.folder?.invoice?.rembourser > 0 ? item?.rembourser : item?.montant, disabled: true }],
            paye: [{ value: this.folder?.invoice?.rembourser > 0 ? 0 : item?.paye, disabled: true }],
            impaye: [{ value: this.folder?.invoice?.rembourser > 0 ? item?.rembourser : item?.impaye, disabled: true }]
          })
        )
      })

      console.log('Factures chargées:', this.invoices.length);
      console.log('Option controls créés:', arr.length);
    }
    return arr;
  }

  onSelectAllInvoice($event) {
    let total = 0
    let paye = 0
    let impaye = 0
    this.option.controls.forEach(item => {
      // @ts-ignore
      var ligne = item.getRawValue()
      item.get('checked').setValue($event.target.checked)
      if ($event.target.checked === true) {
        this.isHidden = true
        total += ligne.montant
        paye += ligne.paye
        impaye += ligne.impaye
      }
      if ($event.target.checked === false) {
        this.isHidden = false
      }
    })
    this.f.montant.setValue(impaye)
    this.montantTotal = total
    this.montantRestant = impaye
    this.montantRegle = paye
    if (this.folder?.invoice?.rembourser > 0) {
      this.isHidden = true
    }
  }

  onSelectInvoice() {
    let i = 0
    let total = 0
    let paye = 0
    let impaye = 0
    this.option.controls.forEach(item => {
      // @ts-ignore
      var ligne = item.getRawValue()
      if (ligne.checked === true) {
        i += 1
        total += ligne.montant
        paye += ligne.paye
        impaye += ligne.impaye
      }
      this.isHidden = i > 1 ? true : false
    })
    this.f.montant.setValue(impaye)
    this.montantTotal = total
    this.montantRestant = impaye
    this.montantRegle = paye
    if (this.folder?.invoice?.rembourser > 0) {
      this.isHidden = true
    }
  }

  onSelectAllEcheance($event) {
    if ($event.target.checked) {
      this.isHidden = true
    } else {
      this.isHidden = false
    }
    var mtn = 0;
    this.echeanceFolders.controls.forEach(item => {
      item.get('checked').setValue($event.target.checked)
      if (item.get('checked').value) {
        mtn += item.get('montant').value
      }
    })
    this.f.montant.setValue(mtn)
  }

  onSelectEcheance(item) {
    var count = 0;
    var mtn = 0;
    this.echeanceFolders.controls.forEach(item => {
      if (item.get('checked').value) {
        count += 1;
        mtn += item.get('montant').value
      }
    })
    this.f.montant.setValue(mtn)
    if (count > 1) {
      this.isHidden = true
    } else {
      this.isHidden = false
    }
  }

  onSelectAllAdvance($event) {
    this.avanceFolders.controls.forEach(item => {
      item.get('checked').setValue($event.target.checked)
    })
  }

  onChangeLibelle() {
    if (this.f.mode.value === 'VIREMENT' || this.f.mode.value === 'VERSEMENT') {
      this.numeroTitle = "N° virement"
      this.sourceTitle = "Banque"
    } else if (this.f.mode.value === 'CHEQUE') {
      this.sourceTitle = "Banque"
      this.numeroTitle = "N° cheque"
    } else if (this.f.mode.value === 'MOBILE MONEY' || this.f.mode.value === 'WAVE') {
      this.sourceTitle = "N° Téléphone"
      this.numeroTitle = "N° Transaction"
    }
    this.f.source.setValue(null)
    this.f.numero.setValue(null)
  }

  onChangeEffectue() {
    this.f.tiers.setValue(null)
  }

  /**
   * Extrait les UUIDs des échéances sélectionnées
   */
  getSelectedEcheanceUuids(): string[] {
    const selectedUuids: string[] = [];

    this.echeanceFolders.controls.forEach(item => {
      if (item.get('checked').value) {
        const uuid = item.get('uuid').value;
        if (uuid) {
          selectedUuids.push(uuid);
        }
      }
    });

    return selectedUuids;
  }

  /**
   * Extrait les UUIDs des avances sélectionnées
   */
  getSelectedAdvanceUuids(): string[] {
    const selectedUuids: string[] = [];

    this.avanceFolders.controls.forEach(item => {
      if (item.get('checked').value) {
        const uuid = item.get('uuid').value;
        if (uuid) {
          selectedUuids.push(uuid);
        }
      }
    });

    return selectedUuids;
  }

  onSubmit() {
    this.submit = true;

    // ✅ NOUVEAU : Permettre montant = 0 si on utilise le wallet
    const montantSaisi = this.f.montant.value || 0;

    if (montantSaisi === 0 && !this.utiliserWallet) {
      this.toast('Veuillez saisir un montant ou utiliser le crédit wallet.', 'Montant requis', 'warning');
      return;
    }

    if (montantSaisi < 0) {
      this.toast('Le montant ne peut pas être négatif.', 'Montant invalide', 'warning');
      return;
    }

    // Vérifier qu'il y a un montant total disponible
    const montantTotal = this.utiliserWallet ?
      montantSaisi + (this.montantWalletUtilise || 0) : montantSaisi;

    if (montantTotal <= 0) {
      this.toast('Aucun montant disponible pour le paiement.', 'Montant insuffisant', 'warning');
      return;
    }
    if (this.folder?.modalite === "ECHEANCE") {
      var i = 0
      this.echeanceFolders.controls.forEach(item => {
        if (item.get('checked').value) { i = i + 1 }
      });
      if (i === 0) {
        Swal.fire({
          title: '',
          text: "Voulez-vous vraiment enregistrer cet paiement sans selectionner d'échéance ?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'primary',
          cancelButtonColor: '#F5ce4b',
          confirmButtonText: 'Oui',
          cancelButtonText: 'Non'
        }).then((result) => {
          if (result.isConfirmed) { this.send() }
        })
      } else {
        this.send()
      }
    } else if (this.folder?.modalite === "AVANCEMENT") {
      var i = 0
      this.avanceFolders.controls.forEach(item => {
        if (item.get('checked').value) { i = i + 1 }
      });
      if (i === 0) {
        Swal.fire({
          title: '',
          text: "Voulez-vous vraiment enregistrer cet paiement sans selectionner d'avance ?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'primary',
          cancelButtonColor: '#F5ce4b',
          confirmButtonText: 'Oui',
          cancelButtonText: 'Non'
        }).then((result) => {
          if (result.isConfirmed) { this.send() }
        })
        return
      } else {
        this.send()
      }
    } else {
      this.send()
    }
  }

  onConfirme() {
    Swal.fire({
      title: '',
      text: 'Confirmez-vous l\'enregistrement ?',
      icon: 'warning',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'Confirmer <i class="fas fa-check"></i>',
      cancelButtonText: 'Annuler <i class="feather icon-x-circle"></i>',
      confirmButtonColor: '#1bc943',
      reverseButtons: true
    }).then((willDelete) => {
      if (!willDelete.dismiss) {
        this.onSubmit();
      }
    });
  }

  send() {
    if (!this.form.invalid) {
      const data = this.form.getRawValue();

      // Normaliser montant : null → 0
      const montantSaisi = data.montant ? Number(data.montant) : 0;
      data.montantVerse = montantSaisi;

      // Calculer le total des échéances sélectionnées
      let totalEcheancesSelectionnees = 0;
      this.echeanceFolders.controls.forEach(control => {
        if (control.get('checked').value) {
          totalEcheancesSelectionnees += control.get('montant').value || 0;
        }
      });

      // Ajouter les données du wallet
      data.utiliserWallet = this.utiliserWallet;
      if (this.utiliserWallet && this.montantWalletUtilise > 0) {
        // Plafonner le wallet au montant restant à couvrir (échéances - espèces)
        const montantRestantACouvrirParWallet = Math.max(0, totalEcheancesSelectionnees - montantSaisi);
        data.montantWalletUtilise = Math.min(this.montantWalletUtilise, montantRestantACouvrirParWallet);
      } else {
        data.montantWalletUtilise = 0;
      }

      // Envoyer uniquement le montant cash — le backend combine cash + wallet
      data.montant = montantSaisi;

      // Si paiement uniquement par wallet, forcer le mode WALLET
      if (montantSaisi === 0 && data.utiliserWallet && data.montantWalletUtilise > 0) {
        data.mode = 'WALLET';
      }

      // Extraire les UUIDs sélectionnés
      const selectedEcheances = this.getSelectedEcheanceUuids();
      const selectedAvances = this.getSelectedAdvanceUuids();

      // Ajouter les UUIDs et le type de paiement aux données
      data.selectedEcheances = selectedEcheances;
      data.selectedAvances = selectedAvances;
      data.typePaiement = this.typePaiement;

      console.log('Montant cash envoyé:', data.montant);
      console.log('Montant wallet envoyé:', data.montantWalletUtilise);
      console.log('Montant total (cash + wallet):', data.montant + data.montantWalletUtilise);
      console.log('Mode:', data.mode);

      this.paymentCustomerService.add(data).subscribe(res => {
        if (res?.status === 'success') {
          this.modal.close('ferme');
          if (data?.uuid) {
            this.paymentCustomerService.getPrinter('SHOW', this.userSession?.agencyKey, this.userSession?.uuid, res?.data?.uuid);
            this.emitter.emit({ action: 'PAYMENT_CUSTOMER_UPDATED', payload: res?.data });
          } else {
            res.data.forEach(item => {
              this.paymentCustomerService.getPrinter('SHOW', this.userSession?.agencyKey, this.userSession?.uuid, item?.uuid);
            })
            this.emitter.emit({ action: 'PAYMENT_CUSTOMER_ADD', payload: res?.data });
          }
        }
      });
    } else {
      return;
    }
  }

  files(data) {
    if (data && data !== null) {
      data.forEach(item => {
        this.folderf.push(
          this.formBuild.group({
            uuid: [item?.uuid, [Validators.required]],
            name: [item?.name],
            path: [item?.path]
          })
        );
      });
    }
  }

  upload(files): void {
    for (const file of files) {
      this.uploadService.upload(file);
    }
  }

  setParam(property, value): void {
    if (value) {
      if (this.form.value.hasOwnProperty(property)) {
        Object.assign(this.form.value, { [property]: value });
      }
      if (this.form.controls.hasOwnProperty(property)) {
        this.form.controls[property].setValue(value);
      }
    }
  }

  @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (event.keyCode === this.ESCAPE_KEYCODE) {
      this.onClose()
    }
  }

  onClose() {
    if (!this.edit && this.form.value.folderUuid) {
      var data = { uuid: this.form.value.folderUuid, path: 'paiement_client' }
      this.uploadService.getDelete(data).subscribe((res: any) => {
        if (res) {
          if (res?.status === 'success') {
            this.form.reset()
            this.modal.close('ferme');
          }
        }
        return res
      });
    } else {
      this.form.reset()
      this.modal.close('ferme');
    }
  }

  onReset() {
    if (this.form.value.folderUuid) {
      this.toast('Impossible de de vider le formulaire lorsque un upload a été éffectué', 'Une erreur a été rencontrée', 'warning');
    } else {
      this.form.reset()
    }
  }

  onChangeFolder(event) {
    this.folder = null;
  }

  // ✅ NOUVELLES MÉTHODES pour la gestion du wallet

  /**
   * Charger le wallet du client sélectionné
   */
  loadWallet(): void {
    const customerUuid = this.f.customer.value;
    if (!customerUuid) {
      this.wallet = null;
      return;
    }

    this.loadingWallet = true;
    this.walletService.getWallet(customerUuid).subscribe(
      (response: any) => {
        // ✅ Transformer snake_case → camelCase
        const walletData = response.wallet || response.data?.wallet;
        if (walletData) {
          this.wallet = {
            id: walletData.id || 0,
            uuid: walletData.uuid || '',
            code: walletData.code || '',
            solde: walletData.solde_actuel || 0,
            detteExigible: walletData.dette_exigible || 0,
            detteFuture: walletData.dette_future || 0,
            detteTotale: walletData.dette_totale || 0,
            creditDisponible: walletData.credit_disponible || 0,
            etat: walletData.etat || 'EQUILIBRE',
            statutClient: walletData.statut_client || 'A_JOUR',
            echeancesEnRetard: walletData.echeances_en_retard || 0,
            montantEnRetard: walletData.montant_en_retard || 0,
            prochaineEcheance: walletData.prochaine_echeance || null,
            montantProchaineEcheance: walletData.montant_prochaine_echeance || 0,
            messageEtat: walletData.message_etat || '',
            peutAcheter: walletData.peut_acheter || false,
            niveauRisque: walletData.niveau_risque || 'FAIBLE',
            dateMiseAJour: walletData.date_mise_a_jour || undefined
          };

          console.log('✅ Wallet chargé:', this.wallet);
          console.log('💰 Crédit disponible:', this.wallet.creditDisponible, 'FCFA');
        } else {
          this.wallet = null;
        }

        this.loadingWallet = false;
        this.calculerMontantAvecWallet();
      },
      error => {
        console.error('❌ Erreur chargement wallet:', error);
        this.loadingWallet = false;
        this.wallet = null;
      }
    );
  }

  /**
   * Gérer le changement de la checkbox "Utiliser wallet"
   */
  onUtiliserWalletChange(): void {
    if (this.utiliserWallet && this.wallet) {
      // Par défaut, proposer tout le crédit disponible
      this.montantWalletSaisi = this.wallet.creditDisponible;
      // Auto-sélectionner le mode de paiement WALLET si montant physique = 0
      if ((this.f.montant.value || 0) === 0) {
        this.f.mode.setValue('WALLET');
      }
    } else {
      this.montantWalletSaisi = 0;
      // Revenir au mode par défaut si on désactive le wallet
      if (this.f.mode.value === 'WALLET') {
        this.f.mode.setValue('ESPECE');
      }
    }
    this.calculerMontantAvecWallet();
  }

  /**
   * ✅ NOUVEAU : Calculer le total des échéances dues
   */
  calculerMontantEcheancesDues() {
    this.montantEcheancesDues = 0;

    this.echeanceFolders.controls.forEach(control => {
      const montant = control.get('montant').value || 0;
      this.montantEcheancesDues += montant;
    });
  }

  /**
   * ✅ CORRIGÉ : Calculer le montant avec utilisation du wallet
   * Le wallet en CRÉDIT = argent en AVANCE → On l'AJOUTE au montant saisi
   */
  calculerMontantAvecWallet(): void {
    let montantSaisi = this.f.montant.value || 0;
    let montantTotalDisponible = montantSaisi;

    if (this.utiliserWallet && this.wallet && this.wallet.creditDisponible > 0) {
      const creditDisponible = this.wallet.creditDisponible;

      // En mode AUTOMATIQUE : utiliser le total de TOUTES les échéances (pas seulement cochées)
      // En mode MANUELLE : utiliser le total des échéances cochées
      let totalEcheancesCibles = 0;
      this.echeanceFolders.controls.forEach(control => {
        if (this.modeRepartition === 'AUTOMATIQUE' || control.get('checked').value) {
          totalEcheancesCibles += control.get('montant').value || 0;
        }
      });

      // Le wallet couvre uniquement ce que les espèces ne couvrent pas
      const montantRestantACouvrir = Math.max(0, totalEcheancesCibles - montantSaisi);

      // Plafonner au crédit disponible ET au montant restant à couvrir
      // Mais respecter le montant saisi par l'utilisateur s'il en a saisi un
      const plafondWallet = Math.min(creditDisponible, montantRestantACouvrir);
      if (this.montantWalletSaisi > 0 && this.montantWalletSaisi <= plafondWallet) {
        // Respecter le montant saisi par l'utilisateur (paiement partiel)
        this.montantWalletUtilise = this.montantWalletSaisi;
      } else {
        this.montantWalletSaisi = plafondWallet;
        this.montantWalletUtilise = plafondWallet;
      }

      montantTotalDisponible = montantSaisi + this.montantWalletUtilise;
      this.montantRestantAPayer = Math.max(0, totalEcheancesCibles - montantTotalDisponible);
    } else {
      this.montantWalletUtilise = 0;
      this.montantWalletSaisi = 0;
      this.montantRestantAPayer = montantSaisi;
    }

    // Répartir le montant TOTAL disponible sur les échéances
    if (this.folder?.modalite === "ECHEANCE") {
      this.calculerRepartitionEcheances(montantTotalDisponible);
    }
  }

  /**
   * Quand l'utilisateur change le montant wallet à utiliser
   */
  onMontantWalletChange(): void {
    if (this.wallet) {
      // Plafonner au crédit disponible
      if (this.montantWalletSaisi > this.wallet.creditDisponible) {
        this.montantWalletSaisi = this.wallet.creditDisponible;
      }
      if (this.montantWalletSaisi < 0) {
        this.montantWalletSaisi = 0;
      }
    }
    this.calculerMontantAvecWallet();
  }

  /**
   * ✅ NOUVEAU : Calculer la répartition sur les échéances
   */
  calculerRepartitionEcheances(montantDisponible: number) {
    this.repartitionPreview = [];
    this.montantSurplus = 0;

    if (this.modeRepartition === 'AUTOMATIQUE') {
      // Répartition automatique par ordre de date
      let montantRestant = montantDisponible;

      // Trier les échéances par date
      const echeancesTriees = [...this.echeanceFolders.controls].sort((a, b) => {
        const dateA = new Date(a.get('date').value);
        const dateB = new Date(b.get('date').value);
        return dateA.getTime() - dateB.getTime();
      });

      echeancesTriees.forEach(control => {
        if (montantRestant <= 0) {
          return;
        }

        const montantEcheance = control.get('montant').value || 0;

        if (montantRestant >= montantEcheance) {
          // Paiement complet de cette échéance
          this.repartitionPreview.push({
            uuid: control.get('uuid').value,
            date: control.get('date').value,
            montantEcheance: montantEcheance,
            montantAffecte: montantEcheance,
            type: 'COMPLET'
          });
          montantRestant -= montantEcheance;

          // Auto-cocher l'échéance
          control.get('checked').setValue(true);
        } else {
          // Paiement partiel
          this.repartitionPreview.push({
            uuid: control.get('uuid').value,
            date: control.get('date').value,
            montantEcheance: montantEcheance,
            montantAffecte: montantRestant,
            type: 'PARTIEL'
          });
          control.get('checked').setValue(true);
          montantRestant = 0;
        }
      });

      // Le surplus va au wallet
      this.montantSurplus = montantRestant;

      // Calculer le total des échéances auto-cochées
      this.montantEcheancesSelectionnees = 0;
      this.echeanceFolders.controls.forEach(control => {
        if (control.get('checked').value) {
          this.montantEcheancesSelectionnees += control.get('montant').value || 0;
        }
      });

    } else {
      // Mode manuel : répartir sur les échéances sélectionnées
      let montantRestant = montantDisponible;

      // Calculer le total des échéances sélectionnées
      this.montantEcheancesSelectionnees = 0;
      this.echeanceFolders.controls.forEach(control => {
        if (control.get('checked').value) {
          this.montantEcheancesSelectionnees += control.get('montant').value || 0;
        }
      });

      // Répartir le montant disponible sur les échéances sélectionnées par ordre de date
      const echeancesSelectionnees = this.echeanceFolders.controls
        .filter(control => control.get('checked').value)
        .sort((a, b) => {
          const dateA = new Date(a.get('date').value);
          const dateB = new Date(b.get('date').value);
          return dateA.getTime() - dateB.getTime();
        });

      echeancesSelectionnees.forEach(control => {
        if (montantRestant <= 0) {
          return;
        }

        const montantEcheance = control.get('montant').value || 0;

        if (montantRestant >= montantEcheance) {
          // Paiement complet de cette échéance
          this.repartitionPreview.push({
            uuid: control.get('uuid').value,
            date: control.get('date').value,
            montantEcheance: montantEcheance,
            montantAffecte: montantEcheance,
            type: 'COMPLET'
          });
          montantRestant -= montantEcheance;
        } else {
          // Paiement partiel de cette échéance
          this.repartitionPreview.push({
            uuid: control.get('uuid').value,
            date: control.get('date').value,
            montantEcheance: montantEcheance,
            montantAffecte: montantRestant,
            type: 'PARTIEL'
          });
          montantRestant = 0;
        }
      });

      // Calculer le surplus (si montant > total sélectionné)
      if (montantDisponible > this.montantEcheancesSelectionnees) {
        this.montantSurplus = montantDisponible - this.montantEcheancesSelectionnees;
      } else {
        this.montantSurplus = 0;
      }
    }
  }

  /**
   * ✅ NOUVEAU : Changer le mode de répartition
   */
  changeModeRepartition(mode: 'AUTOMATIQUE' | 'MANUELLE') {
    this.modeRepartition = mode;
    this.onModeRepartitionChange();
  }

  /**
   * ✅ NOUVEAU : Gérer le changement de mode de répartition
   */
  onModeRepartitionChange() {
    // Désélectionner toutes les échéances avant le recalcul
    this.echeanceFolders.controls.forEach(control => {
      control.get('checked').setValue(false);
    });

    // Recalculer la répartition (en mode AUTO, calculerRepartitionEcheances re-cochera automatiquement)
    this.calculerMontantAvecWallet();
  }

  /**
   * ✅ NOUVEAU : Gérer la sélection/désélection d'une échéance en mode manuel
   */
  onEcheanceCheckChange() {
    // Calculer le total des échéances cochées
    this.montantEcheancesSelectionnees = 0;
    this.echeanceFolders.controls.forEach(control => {
      if (control.get('checked').value) {
        this.montantEcheancesSelectionnees += control.get('montant').value || 0;
      }
    });

    if (this.modeRepartition === 'MANUELLE') {
      this.calculerMontantAvecWallet();
    }
  }

  /**
   * Surveiller les changements du montant pour recalculer avec wallet
   */
  onMontantChange(): void {
    const montant = this.f.montant.value || 0;

    console.log('💰 Changement montant:', {
      montant,
      walletExists: !!this.wallet,
      creditDisponible: this.wallet?.creditDisponible,
      utiliserWallet: this.utiliserWallet
    });

    // ✅ Validation : montant ne peut pas être négatif
    if (montant < 0 && !this.edit) {
      this.f.montant.setValue(0);
      this.toast('Le montant ne peut pas être négatif', 'Montant invalide', 'warning');
      return;
    }

    // Si montant = 0 et wallet disponible, activer automatiquement le wallet + mode WALLET
    if (montant === 0) {
      if (this.wallet && this.wallet.creditDisponible > 0) {
        this.utiliserWallet = true;
        this.montantWalletSaisi = this.wallet.creditDisponible;
        // Auto-sélectionner le mode de paiement WALLET
        if (this.f.mode) {
          this.f.mode.setValue('WALLET');
        }
      }
    } else {
      // Si montant > 0 et mode était WALLET, revenir à ESPECE
      if (this.f.mode && this.f.mode.value === 'WALLET') {
        this.f.mode.setValue('ESPECE');
      }
    }

    // Recalculer avec le wallet
    this.calculerMontantAvecWallet();
  }

  /**
   * Formater un montant en FCFA
   */
  formatMontant(montant: number): string {
    return this.walletService.formatMontant(montant);
  }

  toast(msg, title, type) {
    if (type == 'info') {
      this.toastr.info(msg, title);
    } else if (type == 'success') {
      this.toastr.success(msg, title);
    } else if (type == 'warning') {
      this.toastr.warning(msg, title);
    } else if (type == 'error') {
      this.toastr.error(msg, title);
    }
  }

  get f() { return this.form.controls; }
  get option() { return this.form.get('options') as FormArray; }
  get echeanceFolders() { return this.form.get('echeanceFolders') as FormArray; }
  get avanceFolders() { return this.form.get('avanceFolders') as FormArray; }
  get folderf() { return this.form.get('folders') as FormArray; }
}